import axiosInstance from "./AxiosConfig";

class AppReleaseServerApiService {
  async CreateAppReleaseServer(data) {
    try {
      const response = await axiosInstance.post(
        "/appReleaseServer/createV2",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAppReleaseServer() {
    try {
      const response = await axiosInstance.get("/appReleaseServer/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteAppReleaseServer(id) {
    try {
      const response = await axiosInstance.delete(
        `/appReleaseServer/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateAppReleaseServer(id, data) {
    try {
      const response = await axiosInstance.put(
        `/appReleaseServer/update/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DownloadRelease(filename) {
    try {
      const response = await axiosInstance.get(
        `/appReleaseServer/download/${filename}`,
        { responseType: "blob" }
      );
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new AppReleaseServerApiService();
